import { render, staticRenderFns } from "./UsersManage.vue?vue&type=template&id=2ef2465a&scoped=true&"
import script from "./UsersManage.vue?vue&type=script&lang=js&"
export * from "./UsersManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2465a",
  null
  
)

export default component.exports